@if (userEmail) {
<div class="d-flex align-items-center line-height-initial p-1 bg-surface-2 border-radius-rounded">
    <small class="user-profile__avatar" [style.background-color]="backgroundColor">
        {{ userInitals }}
    </small>
    <small class="margin-end-s">
        {{ userEmail }}
    </small>
</div>
}